import { Route, Navigate } from "react-router-dom";
import { AdminRoute } from "@/components/AdminRoute";
import { PageErrorBoundaryLocal } from "@/components/PageErrorBoundaryLocal";
import { ROUTES } from "@/constants/routes";
import { resilientLazy } from "@/lib/resilientImport";

const Admin = resilientLazy(() => import("@/pages/Admin"), "Admin");
const AdminUsers = resilientLazy(() => import("@/pages/AdminUsers"), "AdminUsers");
const AdminClasses = resilientLazy(() => import("@/pages/AdminClasses"), "AdminClasses");
const AdminAnalytics = resilientLazy(() => import("@/pages/AdminAnalytics"), "AdminAnalytics");
const AdminSettings = resilientLazy(() => import("@/pages/AdminSettings"), "AdminSettings");
const VisualizacaoEstudante = resilientLazy(() => import("@/pages/VisualizacaoEstudante"), "VisualizacaoEstudante");
const AdminOnboardingPreview = resilientLazy(() => import("@/pages/AdminOnboardingPreview"), "AdminOnboardingPreview");
const AdminAvatarManager = resilientLazy(() => import("@/pages/AdminAvatarManager"), "AdminAvatarManager");
const AdminBrandAssets = resilientLazy(() => import("@/pages/AdminBrandAssets"), "AdminBrandAssets");
const AdminImageCuration = resilientLazy(() => import("@/pages/AdminImageCuration"), "AdminImageCuration");
const AdminVideoTest = resilientLazy(() => import("@/pages/AdminVideoTest"), "AdminVideoTest");
const AdminConcierge = resilientLazy(() => import("@/pages/AdminConcierge"), "AdminConcierge");
const AdminCompetitorInsights = resilientLazy(() => import("@/pages/AdminCompetitorInsights"), "AdminCompetitorInsights");
const AdminSeoPages = resilientLazy(() => import("@/pages/AdminSeoPages"), "AdminSeoPages");
const CalendarioPage = resilientLazy(() => import("@/pages/CalendarioPage"), "CalendarioPage");

export const AdminRoutes = () => (
  <>
    <Route 
      path={ROUTES.ADMIN} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Não foi possível carregar o painel administrativo. Tente novamente.">
            <Admin />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.ADMIN_ONBOARDING_PREVIEW} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar pré-visualização de onboarding.">
            <AdminOnboardingPreview />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path="/admin/avatar-manager" 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gerenciador de avatares.">
            <AdminAvatarManager />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path="/admin/brand-assets" 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gerenciador de brand assets.">
            <AdminBrandAssets />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.ADMIN_IMAGE_CURATION} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gerenciador de curadoria de imagens.">
            <AdminImageCuration />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.STUDENT_VIEW}
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar visualização de estudante.">
            <VisualizacaoEstudante />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* New admin pages */}
    <Route 
      path={ROUTES.ADMIN_USERS} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de usuários.">
            <AdminUsers />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.ADMIN_CLASSES} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de turmas.">
            <AdminClasses />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.ADMIN_ANALYTICS} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar analytics.">
            <AdminAnalytics />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    <Route 
      path={ROUTES.ADMIN_SETTINGS} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar configurações.">
            <AdminSettings />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* Video Test Environment */}
    <Route 
      path={ROUTES.ADMIN_VIDEO_TEST} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar ambiente de teste de vídeo.">
            <AdminVideoTest />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* Concierge - Magic Wizard */}
    <Route 
      path={ROUTES.ADMIN_CONCIERGE} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar o Wizard do Mago.">
            <AdminConcierge />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* Competitor Insights - Firecrawl Analysis */}
    <Route 
      path={ROUTES.ADMIN_COMPETITOR_INSIGHTS} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar análise de concorrentes.">
            <AdminCompetitorInsights />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* SEO Landing Pages Admin */}
    <Route 
      path={ROUTES.ADMIN_SEO_PAGES} 
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de SEO.">
            <AdminSeoPages />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      } 
    />
    {/* Calendário dedicado (admin only) */}
    <Route
      path={ROUTES.CALENDAR}
      element={
        <AdminRoute>
          <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar o calendário.">
            <CalendarioPage />
          </PageErrorBoundaryLocal>
        </AdminRoute>
      }
    />
    {/* Compatibility redirect for old subject route */}
    <Route path="/admin/subjects" element={<Navigate to={ROUTES.ADMIN} replace />} />
  </>
);
